import { Component, OnInit, Input } from '@angular/core';
import { StoreService } from './../../store.service'

@Component({
  selector: 'app-skill',
  templateUrl: './skill.component.html',
  styleUrls: ['./skill.component.css']
})
export class SkillComponent implements OnInit {

  @Input() skill : any; 
  thumbUp_class = 'currentUser_unliked'
  thumbUpIcon_class = ''
  constructor( private $store : StoreService) { }

  ngOnInit() {
    if (this.skill.likes[0] !== undefined) {
      // if (this.skill.liked === true) {this.thumbUp_class = 'currentUser_liked'}
      // else {this.thumbUp_class = 'currentUser_unliked'}
      this.skill.likes.find(l => l.endorser && l.endorser.email === this.$store.currentUser.email) ? 
      this.thumbUp_class = 'currentUser_liked'
      : this.thumbUp_class = 'currentUser_unliked'
    }
    console.log()
    if (!this.$store.editModeGlobal) {
      this.thumbUpIcon_class = 'thumbUp_cursor'}
    else {this.thumbUpIcon_class = 'thumbUp_noCursor'}
    
  }

  
  
  likeLoading: boolean
  
    likeSkill (userSkillId) {
      if (!this.$store.editModeGlobal) {
        this.likeLoading = true
        this.$store.likeSkill(userSkillId)
          .catch(err => console.log(err))
          .then(() => {
            if (this.skill.likes[0] !== undefined) {
              this.skill.likes.find(l => l.endorser && l.endorser.email === this.$store.currentUser.email) ? 
              this.thumbUp_class = 'currentUser_liked'
              : (console.log('UNLIKED'), this.thumbUp_class = 'currentUser_unliked')
            }
            else {this.thumbUp_class = 'currentUser_unliked'}
            this.likeLoading = false
          })
      }
    }
  
    
  deleteExpertise(id){
    console.log('ID -----', id)
    this.$store.deleteSkill(id)
      .catch(err => console.log('There was error', err))
  }

  
  

}



// WEBPACK FOOTER //
// C:/Users/Elise/essaiGit3/Converteo-Referentiel-RH/public/src/app/profile/skill/skill.component.ts